export const GET_ADMIN_INFO_SUCCESS = 'GET_ADMIN_INFO_SUCCESS'